<ng-container *ngIf="personas$ | async as personas">
  <ng-container *ngIf="personas.length > 1">
    <ng-container *ngIf="persona$ | async as persona">
      <div (click)="selectPersona()" >{{signature(persona)}}</div>
    </ng-container>
  </ng-container>
</ng-container>
